module.exports = __webpack_public_path__ + "static/img/福壽山.2125fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/福壽山.png?20181011
// module id = e0Nw
// module chunks = 1